import { IMessageHandler } from "../message-handler";
import { IHandlerContext } from "../handler-context";
import { StorageMessage, StorageResponse } from "../../crypto/crypto-types";

interface DeleteUserRequest {
  userId: string;
  password: string;
}

interface DeleteUserResponse {
  success: boolean;
}

export class DeleteUserHandler implements IMessageHandler<DeleteUserRequest> {
  constructor(private context: IHandlerContext) {}

  canHandle(type: string): boolean {
    return type === "DELETE_USER";
  }

  async handle(message: StorageMessage<DeleteUserRequest>, source: Window, origin: string): Promise<void> {
    const { userId, password } = message.data;

    if (!userId || !password) {
      this.context.sendError(source, 'User ID and password required', 'MISSING_DATA', origin, message.requestId);
      return;
    }

    // Verify password before deletion
    const userProfile = await this.context.dbService.getUserById(userId);
    if (!userProfile) {
      this.context.sendError(source, 'User not found', 'USER_NOT_FOUND', origin, message.requestId);
      return;
    }

    await this.context.cryptoEngine.authenticateUser(userProfile, password);
    await this.context.dbService.deleteUser(userId);

    const response: StorageResponse<DeleteUserResponse> = {
      type: 'RESPONSE',
      data: { success: true },
      requestId: message.requestId
    };
    this.context.sendResponse(source, response, origin, message.requestId);
  }
}
